export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/media/logo-mark.png" alt="" aria-hidden="true" className={className} />
);

export const Logo = ({ dark = false }) => (
  <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
    <img
      src="/media/logo.png"
      alt="Krystal Skin And Laser Clinic"
      className={`h-11 w-auto ${dark ? "brightness-0 invert" : ""}`}
    />
  </a>
);
